import React from "react";
import { Celebration } from "../calendar/ordinariate-calendar";
import { CalendarDay } from "../calendar/utils";
import { LoadableDataDependency } from "../utils/RemoteDataProvider";
import { CalCheckLine } from "./CalCheckLine";

export const CalCheckSection: React.FC<{
    day: CalendarDay;
    celebrations: Celebration[];
    outrankedCelebrations: Celebration[];
    isFirstEvensong: string[];
    isMattins: boolean;
    loadableTextList: LoadableDataDependency<string[]>;
}> = (props) => {
    const {
        day,
        celebrations,
        outrankedCelebrations,
        isFirstEvensong,
        isMattins,
        loadableTextList,
    } = props;

    return (
        <div>
            {celebrations.map((celebration) => {
                return (
                    <CalCheckLine
                        day={day}
                        celebration={celebration}
                        hour={
                            isMattins
                                ? "mattins"
                                : isFirstEvensong.find(
                                      (ife) => ife === celebration.label
                                  )
                                ? "first-evensong"
                                : "second-evensong"
                        }
                        loadableTextList={loadableTextList}
                    />
                );
            })}
            <div style={{ opacity: 0.5 }}>
                {outrankedCelebrations.map((celebration) => {
                    return (
                        <CalCheckLine
                            day={day}
                            celebration={celebration}
                            hour={
                                isMattins
                                    ? "mattins"
                                    : isFirstEvensong.find(
                                          (ife) => ife === celebration.label
                                      )
                                    ? "first-evensong"
                                    : "second-evensong"
                            }
                            loadableTextList={loadableTextList}
                        />
                    );
                })}
            </div>
        </div>
    );
};
